'use strict';

const _ = require('lodash');

function ManagerController (
  $http,
  $rootScope,
  $scope,
  $state,
  $window,
  $timeout,
  AnalyticsService,
  IdentityService,
  OrganizationStore,
  ManagerActions,
  ManagerService,
  ManagerStore,
  AppDialogsActions,
  SettingsService,
  PlanStore,
  IntercomService,
  IngestorService,
  DropdownService
) {

  var vm = this;

  vm.planUpsellState = false;
  vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  vm.hasEnabledPlan = PlanStore.get('orgPlan') && PlanStore.get('orgPlan').isEnabled;
  vm.isIngestorUser = IdentityService.isIngestBetaUser();

  vm.hasMultipleOrganizations = SettingsService.hasMultipleOrganizations;
  vm.ASSETS_DOMAIN = $rootScope.CONST.assets_domain;

  vm.changeOrg = () => {

    $state.go('select-organization');
  };

  vm.openSettings = () => {

    $state.go('settings.myProfile');
  };

  vm.openChat = () => {

    IntercomService.show();
    DropdownService._closeGroup('topnav')
  };

  vm.logout = () => {

    $state.go('logout', {}, {
      location: false
    });
  };

  vm.returnHome = () => {

    $state.go('dash.map');
  };

  vm.convertToSubscription = () => {

    window.open('https://www.skycatch.com/pricing/#contact_form', '_blank')
    // var subscription = PlanStore.get('externalSubscription');

    // AnalyticsService.track('[CORE] Subscription', 'Enter Flow', {
    //   'remaining_days': (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24),
    //   'state': $state.current.name
    // });
    // AppDialogsActions.GetSelectPlanPage.dispatch();
  };

  vm._handlePlanStoreChange = _.debounce(() => {

    let customer = PlanStore.get('externalCustomer');
    let subscription = PlanStore.get('externalSubscription');
    vm.hasEnabledPlan = PlanStore.get('orgPlan').isEnabled;
    if (subscription) {
      vm.daysLeft = (new Date(subscription.trial_end) - new Date() / 1000) / (60 * 60 * 24);
      if (subscription.status === 'in_trial' && customer.card_status !== "valid") {
        vm.planUpsellState = true;
        if (vm.daysLeft <= 5) {

        }
      }
      else if (subscription.status === 'cancelled') {
        vm.daysLeft = 0;
        vm.planUpsellState = true;
      }
      else {
        vm.planUpsellState = false;
      }
    }
    IngestorService.sendHideTopbarWidget()
    IngestorService.sendShowTopbarWidget()
    vm.canPlanChat = PlanStore.get('orgPlan').isEnabled && PlanStore.checkFeature('organization', 'chat_support');
  }, 900);


  /** Register Flux action listeners **/
  ManagerStore.syncSubscribe();
  vm._handlePlanStoreChange();
  PlanStore.on(PlanStore.Events.Changed, this._handlePlanStoreChange.bind(this), $scope);
}

ManagerController.$inject = [
  '$http',
  '$rootScope',
  '$scope',
  '$state',
  '$window',
  '$timeout',
  'AnalyticsService',
  'IdentityService',
  'OrganizationStore',
  'ManagerActions',
  'ManagerService',
  'ManagerStore',
  'AppDialogsActions',
  'SettingsService',
  'PlanStore',
  'IntercomService',
  'IngestorService',
  'DropdownService'
];

module.exports = ManagerController;



// WEBPACK FOOTER //
// ./src/app/manager/ManagerController.js